export default __webpack_public_path__ + "static/media/Workshop.65df8747.png";